export interface SupportedLanguage {
  code: string;
  name: string;
  shortLabel: string;
  flag?: string;
}

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { code: "en", name: "English", shortLabel: "EN", flag: "🇺🇸" },
  { code: "id", name: "Bahasa Indonesia", shortLabel: "ID", flag: "🇮🇩" },
  { code: "zh-CN", name: "简体中文", shortLabel: "CN", flag: "🇨🇳" },
];

export function resolveSupportedLanguage(languageCode?: string | null): SupportedLanguage {
  if (!languageCode) {
    return SUPPORTED_LANGUAGES[0];
  }

  const normalizedCode = languageCode.toLowerCase();
  const baseLanguage = normalizedCode.split('-')[0];

  return (
    // Exact match
    SUPPORTED_LANGUAGES.find(({ code }) => code.toLowerCase() === normalizedCode) ??
    // Match by base language (e.g., 'zh' matches 'zh-CN')
    SUPPORTED_LANGUAGES.find(({ code }) => code.toLowerCase().startsWith(baseLanguage)) ??
    // Default fallback
    SUPPORTED_LANGUAGES[0]
  );
}
